export default __webpack_public_path__ + "static/100--stacked-column-daaf64f5b5fe15297f1eaedd8c58a7bf.png";